import React, { useState, useEffect, useMemo, useContext } from "react";
import { Container, Row, Col, Card } from "reactstrap";
import { useNavigate } from "react-router-dom";
import "../sass/home.scss";
import MetaData from "../../components/MetaData";
import TextSlicer from "../../components/TextSlicer";
import OwlCarousel from "react-owl-carousel";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import FAQAccordion from "../../components/FAQAccordion";
import { ThemeContext } from "../../context/theme/ThemeContext";
import logo_white from "../../images/logo_white.png";
import logo_black from "../../images/logo_black.png";
import {
  erp_business_1,
  erp_business_2,
  erp_business_3,
  erp_business_4,
  erp_business_5,
  erp_business_6,
  erp_image_1,
  Softorithm_Black_Logo,
  Softorithm_White_Logo,
} from "../../images";

// Static review data from GoogleReviewSection
const staticReviews = [
  {
    id: 1,
    name: "Kimberly Noyce",
    rating: 5,
    text: "Highly recommend !!!! Ali did a great job with all of the projects I gave him. Lots of patience and very fast. Very knowledgeable with marketing, websites, social media platforms etc. Responded quickly to all of my questions and was very patient when I changed my mind on different things.",
    timeAgo: "6 years ago",
    avatar:
      "https://images.unsplash.com/photo-1524504388940-b1c1722653e1?w=50&h=50&fit=crop&crop=face",
  },
  {
    id: 2,
    name: "Benoit",
    rating: 5,
    text: "Thank you for your services for our business. Really satisfied with your service and reports.",
    timeAgo: "6 years ago",
    avatar:
      "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=50&h=50&fit=crop&crop=face",
  },
  {
    id: 3,
    name: "A-D Rehman",
    rating: 5,
    text: "I joined SoftoRithm for AI Creation and Graphic Designing classes, and it's been an amazing experience. The instructors are skilled, supportive, and make learning easy and practical. The courses are well-structured, blending real-world …More",
    timeAgo: "3 months ago",
    avatar:
      "https://images.unsplash.com/photo-1517841905240-472988babdf9?w=50&h=50&fit=crop&crop=face",
  },
  {
    id: 4,
    name: "huzaifah butt",
    rating: 5,
    text: "SoftoRithm Technologies is an outstanding digital marketing agency. Their team is professional, and they know exactly what they are doing. They have provided me the best web development services. They are not only experts in web development.",
    timeAgo: "2 months ago",
    avatar:
      "https://images.unsplash.com/photo-1502685104226-ee32379fefbe?w=50&h=50&fit=crop&crop=face",
  },
  {
    id: 5,
    name: "AD",
    rating: 5,
    text: "The team of SoftoRithm Technologies is very cooperative and experienced. They have achieved all goals and given the perfect e-commerce website for my jewelry business. Highly recommend their affordable services in the region of Jalalpur Jattan.",
    timeAgo: "4 months ago",
    avatar:
      "https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?w=50&h=50&fit=crop&crop=face",
  },
  {
    id: 6,
    name: "Azeem Ashraf",
    rating: 5,
    text: "A great name in the SEO business. I've had the pleasure of working with them. Excellent services and exceptional customer service. Highly recommended for business of all sizes from all industries!",
    timeAgo: "6 years ago",
    avatar:
      "https://images.unsplash.com/photo-1520813792240-56fc4a3765a7?w=50&h=50&fit=crop&crop=face",
  },
  {
    id: 7,
    name: "Muhammad Mubashir",
    rating: 5,
    text: "Best experience of SEO services. Really appreciated!",
    timeAgo: "6 years ago",
    avatar:
      "https://images.unsplash.com/photo-1511367461989-f85a21fda167?w=50&h=50&fit=crop&crop=face",
  },
  {
    id: 8,
    name: "wahab ijaz",
    rating: 5,
    text: "Best SEO services provider.",
    timeAgo: "6 years ago",
    avatar: "",
  },
  {
    id: 9,
    name: "Talha Ahmad",
    rating: 5,
    text: "Great. Highly Recommended. Keep it up!",
    timeAgo: "6 years ago",
    avatar:
      "https://images.unsplash.com/photo-1547425260-76bcadfb4f2c?w=50&h=50&fit=crop&crop=face",
  },
  {
    id: 10,
    name: "saqib ali",
    rating: 5,
    text: "Great service. Satisfied.",
    timeAgo: "6 years ago",
    avatar: "",
  },
  {
    id: 11,
    name: "anonymous account",
    rating: 5,
    text: "Good and efficient service .. .Best quality",
    timeAgo: "6 years ago",
    avatar:
      "https://images.unsplash.com/photo-1535713875002-d1d0cf377fde?w=50&h=50&fit=crop&crop=face",
  },
  {
    id: 12,
    name: "Sadda Hussain",
    rating: 5,
    text: "Excellent SEO Services",
    timeAgo: "6 years ago",
    avatar:
      "https://images.unsplash.com/photo-1545996124-0501ebae84d0?w=50&h=50&fit=crop&crop=face",
  },
  {
    id: 13,
    name: "Ayesha Khalid",
    rating: 5,
    text: "Excellent service",
    timeAgo: "6 years ago",
    avatar:
      "https://images.unsplash.com/photo-1529626455594-4ff0802cfb7e?w=50&h=50&fit=crop&crop=face",
  },
  {
    id: 14,
    name: "ch waqas",
    rating: 5,
    text: "Good servises👍👍👍",
    timeAgo: "6 years ago",
    avatar:
      "https://images.unsplash.com/photo-1520813792240-56fc4a3765a7?w=50&h=50&fit=crop&crop=face",
  },
  {
    id: 15,
    name: "Al Jehdami International",
    rating: 5,
    text: "Satisfied services",
    timeAgo: "6 years ago",
    avatar:
      "https://images.unsplash.com/photo-1522075469751-3a6694fb2f61?w=50&h=50&fit=crop&crop=face",
  },
  {
    id: 16,
    name: "azaad panchii",
    rating: 5,
    text: "Good service",
    timeAgo: "6 years ago",
    avatar:
      "https://images.unsplash.com/photo-1520813792240-56fc4a3765a7?w=50&h=50&fit=crop&crop=face",
  },
  {
    id: 17,
    name: "pitbull planet",
    rating: 5,
    text: "Excelent services",
    timeAgo: "6 years ago",
    avatar:
      "https://images.unsplash.com/photo-1524504388940-b1c1722653e1?w=50&h=50&fit=crop&crop=face",
  },
];

const services = [
  {
    id: 1,
    title: "ERP Business Software",
    description:
      "SoftoRithm Technologies is offering its best ERP Business software product named Cognitive Solutions to its customer like distributors, manufacturers, wholesalers, retailers, marts, restaurants, pharmacies and others",
    link: "/services/erp-business-software",
    image: erp_business_1,
    color: "#2ca876",
  },
  {
    id: 2,
    title: "Web Design",
    description:
      "A Website is the online identity for businesses in the digital era. A website is what we would like to call the modern business card. Businesses use their website to market their products and services.",
    link: "/services/web-design",
    image: erp_business_2,
    color: "#fcb040",
  },
  {
    id: 3,
    title: "Web Development",
    description:
      "We are living in a digital era. Everything is accessible online and it has made our life easy. The same goes for the business. Previously, the brick and mortar store where the identities of business but now the websites represent them in the online world.",
    image: erp_business_3,
    link: "/services/web-development",
    color: "#ee4036",
  },
  {
    id: 4,
    title: "Digital Marketing",
    description:
      "In this process, we try to enclose all the marketing efforts that are connected to the digital space. We will also cover different digital channels like social media marketing, search engine optimization, websites optimization, and email marketing.",
    link: "/services/digital-marketing",
    image: erp_business_4,
    color: "#2ca876",
  },
  {
    id: 5,
    title: "Web App Development",
    description:
      "SoftoRithm Technologies is proud to inform you that our team of competent web app developers is here to offer you their services. We will cater all your business requirements to offer you the best web application development services for your online running business.",
    image: erp_business_5,
    link:"/services/web-application-development",
    color: "#fcb040",
  },
  {
    id: 6,
    title: "Video Editing & Marketing",
    description:
      "YouTube is the biggest video sharing platform on the internet. Users all over the world including the businesses have their own account on YouTube in which they upload content.",
    link: "/services/video-editing-marketing",
    image: erp_business_6,
    color: "#ee4036",
  },
];

// Video data with YouTube URLs
const videos = [
  {
    id: 1,
    title: "ERP Cognitive Solutions at GT Mart, Gujrat",
    youtubeUrl: "https://youtube.com/shorts/Gvz9XosXo6w?si=7kP0ZSv2R4G-nn25",
    thumbnail: "https://img.youtube.com/vi/Gvz9XosXo6w/maxresdefault.jpg",
  },
  {
    id: 2,
    title: "Bhaiya Trader Wholesaler, Gujrat",
    youtubeUrl: "https://youtube.com/shorts/2B1mzzdCnb4?si=71cpKFzphUfWXmDH",
    thumbnail: "https://img.youtube.com/vi/2B1mzzdCnb4/maxresdefault.jpg",
  },
  {
    id: 3,
    title: "Yashfa Mega Store, Jalalpur Jattan, District Gujrat",
    youtubeUrl: "https://youtube.com/shorts/_d_vAT5Uhh8?si=-7NMlfiV3zDZrceO",
    thumbnail: "https://img.youtube.com/vi/_d_vAT5Uhh8/maxresdefault.jpg",
  },
  {
    id: 4,
    title: "Lala G Cosmetics Store, Jalalpur Jattan, District Gujrat",
    youtubeUrl: "https://youtube.com/shorts/8P5QTEzZqKI?si=YKlVw0qmut8Oy2mR",
    thumbnail: "https://img.youtube.com/vi/8P5QTEzZqKI/maxresdefault.jpg",
  },
];

// Helper function to convert YouTube URL to embed format
const getYouTubeEmbedUrl = (url) => {
  if (!url) return "";

  // If already an embed URL, return as is
  if (url.includes("embed")) {
    return url;
  }

  // Handle YouTube Shorts URLs
  if (url.includes("/shorts/")) {
    const shortsMatch = url.match(/\/shorts\/([^?&#]+)/);
    if (shortsMatch && shortsMatch[1]) {
      return `https://www.youtube.com/embed/${shortsMatch[1]}`;
    }
  }

  // Extract video ID from various YouTube URL formats
  const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
  const match = url.match(regExp);
  const videoId = match && match[2].length === 11 ? match[2] : null;

  if (videoId) {
    return `https://www.youtube.com/embed/${videoId}`;
  }

  return url;
};

const Home = () => {
  const navigate = useNavigate();
  const { themeColor } = useContext(ThemeContext);
  const [showDiv, setShowDiv] = useState(false);
  const [reviewItems, setReviewItems] = useState(3);
  const [videoItems, setVideoItems] = useState(4);

  // Determine which logo to use based on theme
  const isDarkTheme = themeColor === "#181818";
  const logoImage = isDarkTheme ? logo_black : logo_white;

  useEffect(() => {
    setShowDiv(true);
  }, []);

  const handleResize = () => {
    let itemsValue;
    if (window.innerWidth <= 768) {
      itemsValue = 1;
    } else {
      itemsValue = 3; // Show 3 reviews per row on desktop
    }
    setReviewItems(itemsValue);
  };

  const handleVideoResize = () => {
    let itemsValue;
    if (window.innerWidth <= 992) {
      itemsValue = 1;
    } else if (window.innerWidth <= 1200) {
      itemsValue = 2;
    } else if (window.innerWidth <= 1400) {
      itemsValue = 3;
    } else {
      itemsValue = 4;
    }
    setVideoItems(itemsValue);
  };

  useEffect(() => {
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  // OwlCarousel options for reviews
  const reviewCarouselOptions = useMemo(
    () => ({
      loop: true,
      margin: 30,
      responsiveClass: true,
      dots: false,
      nav: true,
      rewind: true,
      autoplay: true,
      smartSpeed: 700,
      autoplayTimeout: 5000,
      responsive: {
        0: {
          items: 1,
        },
        992: {
          items: 3,
        },
      },
    }),
    [],
  );

  // OwlCarousel options for videos (aligned with Tools carousel)
  const videoCarouselOptions = useMemo(
    () => ({
      loop: false,
      margin: 30,
      responsiveClass: true,
      dots: false,
      nav: true,
      rewind: true,
      autoplay: true,
      smartSpeed: 700,
      autoplayTimeout: 7000,
      responsive: {
        0: {
          items: 1,
        },
        992: {
          items: 2,
        },
        1200: {
          items: 3,
        },
        1400: {
          items: 4,
        },
      },
    }),
    [],
  );

  useEffect(() => {
    handleVideoResize();
    window.addEventListener("resize", handleVideoResize);
    return () => {
      window.removeEventListener("resize", handleVideoResize);
    };
  }, []);

  return (
    <>
      <MetaData
        metaTitle={"Best ERP Business Software"}
        metaDescription={
          "SoftoRithm Technologies offers Cognitive Solutions - the best ERP Business software for distributors, manufacturers, wholesalers, retailers, marts, restaurants, pharmacies and others."
        }
      />
      <div className="pg_bdy home_page">
        {/* Section 1 - Hero */}
        <Row
          className="justify-content-center"
          style={{
            backgroundColor: isDarkTheme ? "#181818" : "#ffffff",
            padding: "15px",
            margin: "50px 0",
          }}
        >
          <Col xs={12}>
            <Container>
              <Row className="align-items-center">
                <Col lg={6} md={12}
                  className="mb-4 mb-lg-0 text-center text-lg-start"
                >
                  <h1
                    style={{
                      color: isDarkTheme ? "#ffffff" : "#333333",
                      fontSize: "36px",
                      fontWeight: "bold",
                      marginBottom: "16px",
                    }}
                  >
                    Best ERP Business Software
                  </h1>
                  <h2
                    style={{
                      color: isDarkTheme ? "#d0d0d0" : "#555555",
                      fontSize: "18px",
                      lineHeight: "1.6",
                      marginBottom: "12px",
                    }}
                  >
                    Distributors, Manufacturers, Wholesalers, Retailers, Marts,
                    Restaurants, Pharmacies
                  </h2>
                  <p
                    style={{
                      color: isDarkTheme ? "#a0a0a0" : "#777777",
                      fontSize: "15px",
                      lineHeight: "1.7",
                      marginBottom: "6px",
                    }}
                  >
                    Speed-Up your Invoicing, Accounting, Inventory and Reporting
                  </p>
                  <p
                    style={{
                      color: isDarkTheme ? "#a0a0a0" : "#777777",
                      fontSize: "15px",
                      lineHeight: "1.7",
                    }}
                  >
                    Hire Experts To Optimize Your Digital Presence In Every Way
                    Possible!
                  </p>
                </Col>
                <Col lg={6} md={12} className="text-center">
                  <img
                    src={erp_image_1}
                    alt="ERP Business Software"
                    style={{
                      width: "90%",
                      height: "auto",
                      borderRadius: "8px",
                    }}
                  />
                </Col>
              </Row>
            </Container>
          </Col>
        </Row>

        <div
          className="services_grid_wrapper"
          style={{
            background: "radial-gradient(circle, #2CA876, #181818)",
          }}
        >
          <Container>
            <div className="text-center mb-5">
              <h2 style={{ color: "#ffffff" }}>What We Do!</h2>
            </div>
            <p
              style={{
                color: "rgba(255,255,255,0.9)",
                maxWidth: "860px",
                margin: "10px auto 0",
                fontSize: "15px",
                lineHeight: "1.7",
              }}
              className="mb-3 services_intro_text"
            >
              It’s time to multiply your sales. SoftoRithm Technologies is here
              to help you out with all your business needs that include digital
              marketing, web designing, web, app development and ERP business
              software installation services. Our skilled team is ready to
              assist you in the right way to fulfill all your business goals
              within an affordable price range. Our aim is to bring the quality
              services and affordability under one roof for our valuable
              customers.
            </p>
            <Row className="services_grid">
              {services.map((service, index) => (
                <Col key={service.id} lg={4} md={6} sm={12} className="mb-4">
                  <div
                    className="service_card"
                    style={{
                      backgroundColor: isDarkTheme ? "#494E4C" : "#ffffff",
                      borderColor: "#e7e7e7",
                    }}
                    onClick={() => navigate(service.link)}
                  >
                    <div className="service_card_icon">
                      <img
                        src={service.image}
                        alt={service.title}
                        style={{
                          // width: "48px",
                          // height: "48px",
                          filter: isDarkTheme
                            ? "brightness(0) invert(1)"
                            : "none",
                        }}
                      />
                    </div>
                    <div className="service_card_content">
                      <h4
                        style={{ color: isDarkTheme ? "#ffffff" : "#333333" }}
                      >
                        {service.title}
                      </h4>
                      <p style={{ color: isDarkTheme ? "#d0d0d0" : "#333333" }}>
                        {service.description}
                      </p>
                      <button
                        className={`service_card_btn ${
                          isDarkTheme ? "service_card_btn_dark" : ""
                        }`}
                      >
                        {service.title}
                        <i className="ri-arrow-right-line ms-2"></i>
                      </button>
                    </div>
                  </div>
                </Col>
              ))}
            </Row>
          </Container>
        </div>

        {/* Google Reviews Carousel Section */}
        <div
          className="google_reviews_section py-3"
          style={{
            backgroundColor: isDarkTheme
              ? "#181818"
              : "var(--body-bg-color, #f8f9fa)",
          }}
        >
          <Container>
            <div className="text-center mb-5">
              <h2
                style={{
                  color: "var(--text-color, #333333)",
                  fontSize: "32px",
                  fontWeight: "bold",
                }}
              >
                What People Say About SoftoRithm Technologies
              </h2>
            </div>
            <Row className="align-items-center">
              {/* Left Side - Company Overview */}
              <Col lg={3} md={12} className="mb-4 mb-lg-0">
                <div
                  className="reviews_header mx-auto"
                  style={{ maxWidth: "350px" }}
                >
                  <div
                    className="company_logo mb-3"
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "10px",
                    }}
                  >
                    <img
                      src={
                        isDarkTheme
                          ? Softorithm_White_Logo
                          : Softorithm_Black_Logo
                      }
                      alt="SoftoRithm Logo"
                      style={{
                        objectFit: "contain",
                      }}
                    />
                  </div>

                  <div className="d-flex align-items-center mb-2">
                    <div
                      className="stars me-2"
                      style={{ fontSize: "18px", color: "#FFA500" }}
                    >
                      ★★★★★
                    </div>
                  </div>
                  <p
                    style={{
                      color: "var(--text-muted-color, #666666)",
                      fontSize: "16px",
                      marginBottom: "20px",
                    }}
                  >
                    100+ Google reviews
                  </p>
                  <a
                    href="https://www.google.com/maps/place/SoftoRithm+Technologies/@32.6398578,74.2077532,17z/data=!3m1!4b1!4m6!3m5!1s0x391f1bc75094b907:0xc2b949dd8bcaefa!8m2!3d32.6398578!4d74.2077532!16s%2Fg%2F11n5hbjsyp?entry=ttu&g_ep=EgoyMDI2MDIyNS4wIKXMDSoASAFQAw%3D%3D"
                    target="_blank"
                    rel="noreferrer"
                    className="btn btn-primary"
                    style={{
                      backgroundColor: "#4285F4",
                      borderColor: "#4285F4",
                      color: "#fff",
                      padding: "10px 24px",
                      borderRadius: "6px",
                      fontWeight: "500",
                      textDecoration: "none",
                    }}
                  >
                    Write a review
                  </a>
                </div>
              </Col>

              {/* Right Side - Reviews Carousel (consistent with ERP page) */}
              <Col lg={9} md={12}>
                <OwlCarousel
                  className="owl-theme reviews_carousel"
                  items={reviewItems}
                  {...reviewCarouselOptions}
                >
                  {staticReviews.map((review) => {
                    return (
                      <div
                        key={review.id}
                        className="review_card_item"
                        style={{ padding: "10px" }}
                      >
                        <Card
                          className="review_card"
                          style={{
                            backgroundColor: "var(--card-bg-color, #fff)",
                            border:
                              "1px solid var(--card-border-color, #e7e7e7)",
                            borderRadius: "8px",
                            padding: "20px",
                            height: "100%",
                            boxShadow: "0px 2px 8px rgba(0,0,0,0.1)",
                            display: "flex",
                            flexDirection: "column",
                          }}
                        >
                          <div className="reviewer_info d-flex align-items-center mb-3">
                            {review.avatar ? (
                              <img
                                src={review.avatar}
                                alt={review.name}
                                style={{
                                  width: "40px",
                                  height: "40px",
                                  borderRadius: "50%",
                                  objectFit: "cover",
                                  marginRight: "12px",
                                }}
                              />
                            ) : (
                              <div
                                style={{
                                  width: "40px",
                                  height: "40px",
                                  borderRadius: "50%",
                                  backgroundColor: "#2ca876",
                                  color: "#fff",
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  fontSize: "18px",
                                  fontWeight: "bold",
                                  marginRight: "12px",
                                }}
                              >
                                {review.name.charAt(0).toUpperCase()}
                              </div>
                            )}
                            <div style={{ flex: 1 }}>
                              <div
                                className="d-flex align-items-center"
                                style={{ gap: "6px" }}
                              >
                                <div
                                  style={{
                                    fontWeight: "bold",
                                    color: "var(--text-color, #333333)",
                                    fontSize: "16px",
                                  }}
                                >
                                  {review.name}
                                </div>
                                <svg
                                  width="14"
                                  height="14"
                                  viewBox="0 0 24 24"
                                  fill="none"
                                >
                                  <path
                                    d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"
                                    fill="#4285F4"
                                  />
                                  <path
                                    d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"
                                    fill="#34A853"
                                  />
                                  <path
                                    d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"
                                    fill="#FBBC05"
                                  />
                                  <path
                                    d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"
                                    fill="#EA4335"
                                  />
                                </svg>
                              </div>
                              <div
                                style={{
                                  fontSize: "12px",
                                  color: "var(--text-muted-color, #666666)",
                                }}
                              >
                                {review.timeAgo}
                              </div>
                            </div>
                          </div>

                          <div
                            className="review_stars mb-3"
                            style={{
                              color: "#FFA500",
                              fontSize: "16px",
                              letterSpacing: "0px",
                            }}
                          >
                            {[...Array(review.rating)].map((_, i) => (
                              <span key={i} style={{ marginRight: "2px" }}>
                                ★
                              </span>
                            ))}
                          </div>

                          <div className="review_text">{review.text}</div>
                        </Card>
                      </div>
                    );
                  })}
                </OwlCarousel>
              </Col>
            </Row>
          </Container>
        </div>

        {/* Videos Section */}
        <div
          className="videos_section py-2"
          style={{ backgroundColor: "var(--body-bg-color, #ffffff)" }}
        >
          <Container>
            <div className="videos_header text-center mb-5">
              <h2
                className="mb-3"
                style={{
                  color: "var(--text-color, #333333)",
                  fontSize: "32px",
                  fontWeight: "bold",
                }}
              >
                Our Case Studies and Reviews
              </h2>
            </div>

            <OwlCarousel
              className="owl-theme videos_carousel"
              items={videoItems}
              {...videoCarouselOptions}
            >
              {videos.map((video) => (
                <div
                  key={video.id}
                  className="video_card_item"
                  style={{ padding: "10px" }}
                >
                  <div
                    className="video_card"
                    style={{
                      backgroundColor: "var(--card-bg-color, #fff)",
                      border: "1px solid var(--card-border-color, #e7e7e7)",
                      borderRadius: "8px",
                      overflow: "hidden",
                      boxShadow: "0px 2px 8px rgba(0,0,0,0.1)",
                      transition: "all 0.3s ease-in-out",
                      maxWidth: "100%",
                      margin: "0 auto",
                    }}
                  >
                    <div
                      className="video_embed_wrapper"
                      style={{
                        position: "relative",
                        paddingBottom: "177.78%", // 9:16 portrait aspect ratio for shorts/reels
                        height: 0,
                        overflow: "hidden",
                      }}
                    >
                      <iframe
                        src={getYouTubeEmbedUrl(video.youtubeUrl)}
                        title={video.title}
                        frameBorder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowFullScreen
                        style={{
                          position: "absolute",
                          top: 0,
                          left: 0,
                          width: "100%",
                          height: "100%",
                        }}
                      ></iframe>
                    </div>
                  </div>
                </div>
              ))}
            </OwlCarousel>

            <div className="text-center mt-4">
              <a
                href="https://www.youtube.com/playlist?list=PLUHlpwkQ546e44yYJ9VrnPw4-ZpV_ZB5X"
                target="_blank"
                rel="noreferrer"
                className="btn btn-primary"
                style={{
                  backgroundColor: "#2ca876",
                  borderColor: "#2ca876",
                  color: "#fff",
                  padding: "10px 24px",
                  borderRadius: "6px",
                  fontWeight: "500",
                  textDecoration: "none",
                }}
              >
                View More Case Studies
              </a>
            </div>
          </Container>
        </div>

        {/* FAQ Section */}
        <div
          className="faq_section py-3"
          style={{ backgroundColor: "var(--body-bg-color, #f8f9fa)" }}
        >
          <Container>
            <div className="faq_header text-center mb-5">
              <h2
                className="mb-3"
                style={{
                  color: "var(--text-color, #333333)",
                  fontSize: "32px",
                  fontWeight: "bold",
                }}
              >
                Frequently Asked Questions
              </h2>
            </div>

            <Row className="justify-content-center">
              <Col lg={6}>
                <FAQAccordion
                  faqData={[
                    {
                      question: "What exactly does SoftoRithm Technologies do?",
                      points: [
                        'SoftoRithm Technologies helps businesses become smarter and more organized through technology. We\'re a team of tech experts who do two big things: we give you Cognitive Solutions (our smart software) to organize your internal work, and we handle your Web Design, SEO, and Marketing to help you grow externally. Basically, we handle the tech so you can focus on the "business."',
                      ],
                    },
                    {
                      question:
                        'What is "Cognitive Solutions" and why should I care?',
                      points: [
                        "Think of it as the ultimate personal assistant for your business. If you’re currently juggling messy spreadsheets, paper receipts, or three different apps just to check your stock, you need this. It brings your sales, inventory, and accounts into one simple dashboard. You’ll save time, stop making manual errors, and finally know exactly how much profit you’re making in real-time.",
                      ],
                    },
                    {
                      question:
                        "Is this only for big companies, or can a small shop use it too?",
                      points: [
                        "You don’t need to be a giant corporation to work with us. Whether you’re running a single retail shop, a local mart, or a growing distribution business, we’ve got you. We scale our services to fit your size and budget. Small businesses actually need this the most because it frees up your time to grow!",
                      ],
                    },
                    {
                      question:
                        "Do you provide support and training after installation?",
                      points: [
                        'Not a chance. We know that "new software" can feel intimidating. That’s why we sit down with you and your team to provide full training until everyone feels like a pro. And if you ever have a question or a glitch down the road, we’re just a phone call or a message away. We’re in this for the long haul.',
                      ],
                    },
                    {
                      question:
                        "Can the ERP software be customized according to my business requirements?",
                      points: [
                        'Every business has its own "secret sauce," and we don\'t want to change that. We don\'t just give you a "one-size-fits-all" box. We’ll look at how you actually work and then tweak Cognitive Solutions to match—whether that’s a specific billing style, special discounts, or custom reports that you actually find useful.',
                      ],
                    },
                    {
                      question: "How safe is my business data with you?",
                      points: [
                        'We treat your data with the same care we\'d treat our own. Our system is built with serious security layers and "user permissions"—meaning you get to decide exactly who can see what. Plus, we set up backups so that even if the unexpected happens, your business records stay safe and sound.',
                      ],
                    },
                  ]}
                />
              </Col>
              <Col lg={6}>
                <FAQAccordion
                  faqData={[
                    {
                      question:
                        "Do you only offer ERP software or complete digital solutions?",
                      points: [
                        'We sure do. We\'re a "full-service" digital partner. While our ERP handles the "engine" of your business, our creative team handles the "paint job." From building modern websites and catchy Video Editing Marketing to getting you on the first page of Google with SEO, we make sure you look as good as you operate.',
                      ],
                    },
                    {
                      question:
                        "How can I get started with SoftoRithm Technologies?",
                      points: [
                        'It’s super easy. No high-pressure sales pitches here—just a simple chat. Reach out for a free consultation, tell us where your business is feeling "stuck," and we’ll show you exactly how we can fix it. No tech jargon, just honest solutions to help you move forward.',
                      ],
                    },
                    {
                      question:
                        "What to do if I don’t get my answer here?",
                      points: [
                        "No problem! You can send your query on the contact form and one of our customer support representatives will contact you as soon as possible. You can also visit our office for in-person meetings.",
                      ],
                    },
                    {
                      question:
                        "How much time do you take to respond against a query?",
                      points: [
                        "We try our best to get back to our customers as soon as possible. Usually, you will get a response within 24 to 48 hours.",
                      ],
                    },
                    {
                      question:
                        "Do I have to be local to get the desired services?",
                      points: [
                        "No, you can contact us to get our services from any part of the world. We have a proper management system that allows us to connect with our clients in any corner of the world. You will get the best services irrespective of the place without any compromise on the quality. Our crew is skilled enough to handle the tasks remotely.",
                      ],
                    },
                    {
                      question:
                        "What makes SoftoRithm Technologies better than the competition?",
                      points: [
                        "SoftoRithm Technologies is one of the renowned companies with a proven track record of providing the best services. The competent crew has more than 10 years of experience and you will get the quality services regarding digital marketing, SEO, web designing, web development, app development, and business consulting. You will not have any regrets once you will hire us. We are here for your assistance.",
                      ],
                    },
                  ]}
                />
              </Col>
            </Row>
          </Container>
        </div>
      </div>
    </>
  );
};

export default Home;
